/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultGeomatique } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_pres_019: Question = {
  id: 'pres-019-types-ecosystemes-forestiers',
  oldId: '33',
  title: 'Nombre de types d\'écosystèmes forestiers',
  number: '3.3',
  description: ['(nombre de types écologiques différents selon les données écoforestières)'],
  type: QuestionType.INDICATOR,
  frequency: 3,
  slots: [
    {
      type: SlotTypes.GEOMATIQUE,
      items: [''],
      data: ['0'],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data: string[]) => data,
      score: '0',
      help: defaultGeomatique,
      unit: SlotUnit.NUMBER_OF,
    },
  ],
};

export const question_pres_019_v2: Question = question_pres_019;
export const question_pres_019_v3: Question = question_pres_019;
